import {
    RedTariff,
    YoungTariff,
} from '@vfde-sails/constants';
import { OptionPicker } from '@vfde-brix/ws10/option-picker';

/**
 * Get active subscription from tariff option picker
 */
const getDefaultSubscriptionId = (optionPicker: OptionPicker | null): RedTariff | YoungTariff | null => {
    if (!optionPicker) {
        return null;
    }

    return optionPicker.getValue();
};

export default getDefaultSubscriptionId;
